import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a6a7eba0")

_pushScopeId("data-v-a6a7eba0")
const _hoisted_1 = { class: "p-d-flex p-flex-row kn-height-full" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_DocumentExecutionWordDetail = _resolveComponent("DocumentExecutionWordDetail")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.documentExecutionHelpDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.onlineHelp')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "kn-button p-button-text p-button-rounded",
            onClick: _ctx.closeDialog
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Listbox, {
          class: "kn-list--column kn-flex kn-height-full",
          options: _ctx.words,
          filter: true,
          filterPlaceholder: _ctx.$t('common.search'),
          filterMatchMode: "contains",
          filterFields: _ctx.documentExecutionHelpDialogDescriptor.filterFields,
          emptyFilterMessage: _ctx.$t('common.info.noDataFound')
        }, {
          empty: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          option: _withId((slotProps) => [
            _createVNode("div", {
              class: "kn-list-item",
              onClick: ($event: any) => (_ctx.loadWordDetail(slotProps.option))
            }, [
              _createVNode("span", null, _toDisplayString(slotProps.option.WORD), 1)
            ], 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage"]),
        _createVNode(_component_DocumentExecutionWordDetail, {
          id: "document-execution-word-detail",
          wordDetail: _ctx.wordDetail,
          selectedWordName: _ctx.selectedWordName
        }, null, 8, ["wordDetail", "selectedWordName"])
      ])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})